export interface TransformationRow {
  n: string;
  title: string;
  before: string;
  after: string;
}

export const transformationRows: TransformationRow[] = [
  {
    n: '1/4',
    title: 'Planificación',
    before: 'Noches de domingo buscando ejercicios en YouTube que no terminan de encajar con tu categoría ni con tu campo.',
    after: '−90% tiempo. Sesiones listas en tu móvil en solo 2 clics.'
  },
  {
    n: '2/4',
    title: 'Seguridad',
    before: 'Inseguridad al llegar al campo sin saber si lo que has preparado es lo correcto para el nivel de tus jugadores.',
    after: 'Confianza total. Ejercicios con correcciones clave, variantes y progresiones claras semana a semana.'
  },
  {
    n: '3/4',
    title: 'Variedad',
    before: 'Los mismos 8 ejercicios de siempre que tus jugadores ya hacen en piloto automático.',
    after: '+100% originalidad. Sesiones con condiciones que motivan, desafían y generan aprendizaje real.'
  },
  {
    n: '4/4',
    title: 'Energía',
    before: 'Llegas al campo mentalmente agotado de haber organizado todo desde cero mientras intentabas cenar.',
    after: 'Cero estrés. Llegas con energía para conectar con tus jugadores desde el primer pitido.'
  }
];

export interface TransformationFooterStat {
  value: string;
  label: string;
}

export const transformationFooterStats: TransformationFooterStat[] = [
  { value: '+120h', label: 'Ahorradas al año' },
  { value: '2 clics', label: 'Para cada sesión lista' },
  { value: '100%', label: 'Profesional' }
];
